module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1034235"
    }
  }, [_c('b', [_vm._v("HOT CRABMEAT SPREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1034735"
    }
  }, [_c('b', [_c('i', [_vm._v("The topping of sliced almonds adds another layer of rich flavor and an unexpected crunch to this crowd-pleasing spread.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1036035"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes     Bake: 22 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1036535"
    }
  }, [_vm._v("3 tablespoons sliced almonds")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1036835"
    }
  }, [_vm._v("1 container (8 ounces) lump crabmeat")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1037135"
    }
  }, [_vm._v("1 package (8 ounces) cream cheese, softened")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1037435"
    }
  }, [_vm._v("3 tablespoons minced onion")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1037735"
    }
  }, [_vm._v("1 tablespoon milk")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1038035"
    }
  }, [_vm._v("½ teaspoon prepared white horseradish")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1039035"
    }
  }, [_vm._v("¼ teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1039935"
    }
  }, [_vm._v("⅛ teaspoon coarsely ground black pepper "), _c('br'), _vm._v(" assorted crackers")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1041435"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 375°F. Spread almonds in 8-inch square metal baking pan. Bake 2 to 3 minutes or until lightly toasted. Pick through crabmeat to remove any pieces of shell, making sure not to break up meat.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1043135"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In bowl, stir cream cheese, onion, milk, horseradish, salt, and pepper until blended. Gently stir in crabmeat. Spread mixture into shallow 9-inch ceramic or glass baking dish.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1044835"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Sprinkle almonds over crabmeat mixture. Bake 20 to 25 minutes or until edges brown and center begins to bubble. Serve hot with crackers. Makes about 12 servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1046735"
    }
  }, [_vm._v("Each serving: About 40 calories, 2g protein, 1g carbohydrate, 3g total fat (2g saturated), 0mg fiber, 17mg cholesterol, 70mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eebabfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c20_r1.vue
// module id = 126
// module chunks = 0